import type { JSX } from 'react';
import classNames from 'classnames';
import { Group } from '@mantine/core';
import type { ICardChipsProps } from './types';
import classes from './Card.module.css';

function CardChips({ children, className }: Readonly<ICardChipsProps>): JSX.Element {
  return (
    <Group justify="flex-end" gap="xs" className={classNames(classes.chips, className)}>
      {children}
    </Group>
  );
}

export default CardChips;
